<template>
  <div class="card card-rounded card-shadow border-0 fade-in-up animation-delay"
       style="--delay-index: 1;">
    <div class="card-body">
      <div class="d-flex small justify-content-center align-content-center mb-3">
        <div class="checkmark-container">
          <div class="checkmark draw draw-fast"></div>
        </div>
      </div>
      <h3 class="text-center fade-in-up animation-delay" style="--delay-index: 1;">{{ $t('SurveyPage.thankYou') }}</h3>
      <p class="text-muted text-center mb-5 fade-in-up animation-delay" style="--delay-index: 2;">
        {{ $t('SurveyPage.appreciation') }}
      </p>
      <div @click="$emit('on-survey-completed')"
           class="btn btn-lg btn-primary btn-block text-white mb-3 mt-4 fade-in-up animation-delay"
           style="--delay-index:3;">
        {{ $t('SurveyPage.backToApp') }}
      </div>
    </div>
  </div>
</template>
<script>

export default {
  name: 'SurveyCompleted'
}
</script>
